import type { Uuid } from "@/domains/global/identifiers";
import type { TranscriptArrayItem } from "@/modules/audio-recording/transcript-types";

export enum AudioRecordingTranscriptStatus {
  Ready = "READY",
  Missing = "MISSING",
  Compromised = "COMPROMISED",
}

export type AudioRecordingTranscriptState = {
  status: AudioRecordingTranscriptStatus;
  content: string;
  transcriptArray: TranscriptArrayItem[];
  errorMessage: string | null;
};

export const TRANSCRIPTION_COMPROMISED_ERROR_MESSAGE =
  "Transcription was disconnected. Please retry processing.";

export interface IAudioTranscriptionStore {
  getTranscriptState({
    audioRecordingId,
  }: {
    audioRecordingId: Uuid;
  }): Promise<AudioRecordingTranscriptState>;
  clearTranscriptionStatus({ audioRecordingId }: { audioRecordingId: Uuid }): void;
}
